import IconComponent from "icons/IconComponent";

import ClockIcon from "./clock-icon.svg";

export default (ClockIcon as any) as IconComponent;
